import { render } from "./MetadataSelectView.vue?vue&type=template&id=5bcb10a6&scoped=true"
import script from "./MetadataSelectView.vue?vue&type=script&lang=js"
export * from "./MetadataSelectView.vue?vue&type=script&lang=js"

import "./MetadataSelectView.vue?vue&type=style&index=0&id=5bcb10a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bcb10a6"]])

export default __exports__